import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import GridContainer from "@effektify/components/GridContainer";
import "@effektify/logger";
import "@effektify/types";
import "react";
import "sprintf-js";
import "@effektify/types/guards";
import useVariables from "../hooks/useVariables.js";
import "@effektify/components";
import "@effektify/cache";
import Container from "./Container/Container.js";
import GradientDefs from "./Gradients.js";
const PARENT_ROOT_ID = "composer-root";
const Renderer = t0 => {
  const $ = c(17);
  const {
    parentId: t1,
    content,
    loading: t2
  } = t0;
  const parentId = t1 === void 0 ? PARENT_ROOT_ID : t1;
  const loading = t2 === void 0 ? false : t2;
  const {
    hasMetConditions
  } = useVariables();
  let t3;
  if ($[0] !== hasMetConditions) {
    t3 = conditions => hasMetConditions(conditions);
    $[0] = hasMetConditions;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const shouldRender = t3;
  if (!content || content.length === 0) {
    return null;
  }
  const t4 = `${parentId}-child-wrapper`;
  let t5;
  if ($[2] !== parentId) {
    t5 = parentId === PARENT_ROOT_ID && /* @__PURE__ */jsx(GradientDefs, {});
    $[2] = parentId;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== content || $[5] !== loading || $[6] !== parentId || $[7] !== shouldRender) {
    let t72;
    if ($[9] !== loading || $[10] !== parentId || $[11] !== shouldRender) {
      t72 = (group, idx) => {
        if ("conditions" in group && group.conditions && !shouldRender(group.conditions)) {
          return null;
        }
        return /* @__PURE__ */jsx(Container, {
          content: [group],
          className: "color-scheme-sand",
          loading
        }, `${parentId}-container-${idx}`);
      };
      $[9] = loading;
      $[10] = parentId;
      $[11] = shouldRender;
      $[12] = t72;
    } else {
      t72 = $[12];
    }
    t6 = content.map(t72);
    $[4] = content;
    $[5] = loading;
    $[6] = parentId;
    $[7] = shouldRender;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = /* @__PURE__ */jsxs(GridContainer, {
      children: [t5, t6]
    }, t4);
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export { Renderer as default };